import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const SystemTime = 'SystemTime'
const VerificationCode = "verificationCode"
const Avatar = 'Avatar'
const DiskPath = "diskPath"
const IsManage = 'isManage'
const UserStatus = 'userStatus'
const ThirdUrl = 'thirdUrl'
const UserName = 'userName'
const EndOrgName = 'endOrgName'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function getSysTime() {
  return Cookies.get(SystemTime)
}
export function getIsManage() {
  return Cookies.get(IsManage)
}

export function setIsManage(isManage) {
  return Cookies.set(IsManage, isManage)
}
export function removeIsManage() {
  return Cookies.remove(IsManage)
}
export  function  setSysTime(systemTime) {
  return Cookies.set(SystemTime, systemTime)
}

export  function  removeSysTime() {
  return Cookies.remove(SystemTime)
}

export function getVerificationCode() {
  return Cookies.get(VerificationCode)
}
export function setVerificationCode(verificationCode) {
  return Cookies.set(VerificationCode, verificationCode)
}
export function removeVerificationCode() {
  return Cookies.remove(VerificationCode)
}


export  function  getAvatar() {
  return Cookies.get(Avatar)
}

export  function  setAvatar(avatar) {
  return Cookies.set(Avatar, avatar)
}

export  function  removeAvatar() {
  return Cookies.remove(Avatar)
}

export function setRoletype(roletype) {
  return Cookies.set("roletype", roletype)
}

export function getRoletype() {
  return Cookies.get("roletype")
}
export  function  removeDiskPath() {
  return Cookies.remove(DiskPath)
}

export function setDiskPath(diskPath) {
  return Cookies.set(DiskPath, diskPath)
}

export function getDiskPath() {
  return Cookies.get(DiskPath)
}
export function getUserStatus() {
  return Cookies.get(UserStatus)
}
export function getThirdUrl() {
  return Cookies.get(ThirdUrl)
}
export function setThirdUrl(thirdUrl) {
  return Cookies.set(ThirdUrl, thirdUrl)
}

export function setUserName(userName) {
  return Cookies.set(UserName, userName)
}

export function getUserName() {
  return Cookies.get(UserName)
}
export function setEndOrgName(endOrgName) {
  return Cookies.set(EndOrgName, endOrgName)
}

export function getEndOrgName() {
  return Cookies.get(EndOrgName)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js